let Base64 = require('js-base64').Base64;
export default {
  data() {
    return {
      email: "",
      pwd: "",
      btn_txt: "注册",
      loginData: {}, //账户登录
      show_valid:false,//验证码
      btn_code_txt:"获取验证码",
      valid_code:"",//验证码
      confirm_pwd:"",//确认密码
      timer:"",
      count:60
    }
  },
  methods: {
    changeTab(e) {
      console.log(e)
      this.active = e
    },
    forgetPassword() {
      this.$router.push({
        path: "/ForgetPassword"
      });
    },
    remember() {
      this.is_remember = localStorage.getItem("is_remember");
      this.is_remember = this.is_remember == "true" ? true : false;
      if (this.is_remember) {
        this.email = Base64.decode(localStorage.getItem("email"));
        this.pwd = Base64.decode(localStorage.getItem("pwd"));
        if (this.email && this.pwd) {
          this.login();
        }
      }
    },
    login() {
      if (this.btn_txt == "注册中...") {
        return
      }
      if (!this.loginData.client_name) {
        this.$Message.warning('请输入客户名称');
        return false;
      }
      if (!this.loginData.email) {
        this.$Message.warning('请输入邮箱');
        return false;
      }
      if (!this.loginData.password) {
        this.$Message.warning('请输入密码');
        return false;
      }
      if (this.loginData.password != this.loginData.password_confirm) {
        this.$Message.warning('两次输入的密码不一致');
        return false;
      }
      if (!this.loginData.contact_name) {
        this.$Message.warning('请输入姓名');
        return false;
      }
      if (!this.loginData.contact_phone) {
        this.$Message.warning('请输入电话');
        return false;
      }
      let loginData = {
       ...this.loginData
      }
      this.btn_txt = "注册中...";

      this.$axios.post("/client/register", this.$qs.stringify(loginData)).then(res => {
        if (res.success) {
          //this.show_valid = true;
          this.$Message.success('注册成功,请登录');
          this.$router.replace({
            path: '/Login'
          });
        } else {
          this.btn_txt = "注册";
        }
      })
    },
    /*
     * 获取短信验证码
     */
    getCode(){
    	if(this.count!==60){
    		return
    	}
    	this.$axios.post("/client/email/valid?email="+this.loginData.email).then(res=>{
    		if(res.success){
    			this.timer=null;
    			this.count=60;
    			this.timer=setInterval(()=>{
    				if(this.count>1){
    					this.count-=1;
    					this.btn_code_txt=this.count+"s";
    					return;
    				}
            this.btn_code_txt="获取验证码"
            this.count=60;
    				clearInterval(this.timer);
    			},1000)
    		}
    	})
    },
    complete(){ //完成注册  激活邮箱
      if(!this.valid_code){
        this.$Message.info('请输入验证码');
        return false
      }
      this.$axios.post("/client/email/active",this.$qs.stringify({
        email : this.loginData.email,
        valid_code: this.valid_code
      })).then(res=>{
        if(res.data){
          this.$Message.success('注册成功,请登录');
          this.$router.replace({
            path: '/Login'
          });
        }
      })
    }
  },
  created() {
    this.remember();
  },
  destroyed(){
    if(this.timer){
      clearInterval(this.timer);
    }
  	this.timer=null;
  }
}



// WEBPACK FOOTER //
// ./src/pages/web/register/main.js